import { Link } from "react-router-dom";
import SectionLabel from "@/components/base/SectionLabel";

interface PageHeroProps {
  label: string;
  title: string;
  lead?: string;
  parent?: string;
}

export default function PageHero({ label, title, lead, parent = "Startseite" }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="blueprint absolute inset-0 opacity-60" />
      <div className="absolute -right-24 top-0 h-full w-1/3 bg-gradient-to-l from-primary-500/20 to-transparent" />
      <div className="relative mx-auto w-full max-w-shell px-4 pb-14 pt-14 md:px-6 md:pb-20 md:pt-20">
        <div className="mb-8 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-background-400">
          <Link to="/" className="transition-colors hover:text-primary-300">
            {parent}
          </Link>
          <i className="ri-arrow-right-s-line text-[14px] text-background-600" />
          <span className="text-background-200">{label}</span>
        </div>
        <SectionLabel tone="light" className="mb-6">
          {label}
        </SectionLabel>
        <h1 className="max-w-4xl font-heading text-[34px] font-extrabold leading-[1.05] tracking-tightest text-background-50 sm:text-[44px] md:text-[58px]">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-background-300 md:text-[17px]">
            {lead}
          </p>
        )}
      </div>
      <div className="h-[3px] w-full bg-primary-500" />
    </section>
  );
}